import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const quickLinks = [
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Franchise', path: '/franchise' },
    { name: 'Partner', path: '/partner' },
    { name: 'Contact', path: '/contact' },
    { name: 'Disclaimer', path: '/disclaimer' },
  ];

  return (
    <footer className="relative bg-brand-primary-dark/90 backdrop-blur-xl text-brand-cream/90 text-sm md:text-base py-12 px-6 md:px-12 border-t border-white/20 shadow-[0_-10px_30px_rgba(0,0,0,0.1)] overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" aria-hidden="true" />

      <div className="max-w-6xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
        <div>
          <h4 className="text-xl font-extrabold text-brand-cream mb-3 tracking-wide drop-shadow-sm">
            Eco World Capital
          </h4>
          <p className="leading-relaxed text-base font-medium text-brand-cream-muted/90">
            Empowering Investments Through Technology, Expertise, and Financial Innovation.
          </p>
        </div>
        <div>
          <h4 className="text-lg font-extrabold text-brand-cream mb-3 tracking-wide drop-shadow-sm">
            Quick Links
          </h4>
          <ul className="space-y-2">
            {quickLinks.map((link) => (
              <li key={link.path}>
                <Link
                  to={link.path}
                  className="text-brand-cream-muted/90 hover:text-brand-gold font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold rounded"
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-lg font-extrabold text-brand-cream mb-3 tracking-wide drop-shadow-sm">
            Regulatory Note
          </h4>
          <p className="leading-relaxed text-sm md:text-base font-medium text-brand-cream-muted/90">
            Account handling services, PMS, and loan facilitation items are strictly offered subject to applicable regulatory requirements, legal laws, and approvals.
          </p>
        </div>
        <div>
          <h4 className="text-lg font-extrabold text-brand-cream mb-3 tracking-wide drop-shadow-sm">
            Market Risk Warning
          </h4>
          <p className="leading-relaxed text-sm md:text-base font-medium text-brand-cream-muted/90">
            EWC acts as a technology provider and facilitator. We do not guarantee returns or profits. Trading in financial instruments involves market risks.
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-white/20 flex flex-col md:flex-row justify-between items-center gap-6 text-sm md:text-base relative z-10">
        <p className="font-extrabold text-brand-gold drop-shadow-sm text-center md:text-left">
          © {new Date().getFullYear()},{' '}
          <a
            href="https://100billiontech.com/ownership"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold rounded"
          >
            Copy-rights reserved
          </a>
          <span>. Designed by </span>
          <a
            href="https://100billiontech.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold rounded"
          >
            100billion Tech
          </a>
        </p>
        <p className="text-center md:text-right max-w-xl text-brand-cream-muted/80 font-medium text-xs md:text-sm">
          Clients are advised to assess risks and seek independent financial, legal, and tax advice before investing or borrowing.{' '}
          <Link to="/disclaimer" className="text-brand-gold hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold rounded">
            Read full disclaimer
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
